export default __webpack_public_path__ + "static/media/4.60647f1c.jpg";